import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        id_municipio: '',
        nombre: '',
        id_departamento: '',
        id_operador: '',
        operadores: [],
        departamentosVisita: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { id_municipio, nombre, abreviatura, id_departamento, id_operador } = this.state;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_operador) { errores.push("error_id_operador"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            id_municipio: id_municipio,
            nombre: nombre,
            abreviatura: abreviatura,
            id_departamento: id_departamento,
            id_operador: id_operador
        }
        Swal.showLoading();
        authAxios.post("municipios_operadores/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }

                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Municipios Operadores de Red!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterMunicipiosOperadores");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Municipios Operadores de Red!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentosVisita: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("operadores/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, operadores: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { id_municipio, nombre, abreviatura, id_departamento, departamentosVisita, id_operador, operadores } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE MUNICIPIOS OPERADORES DE RED</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className='col-md-6'>
                                                    <label htmlFor="id_operador">Operador de Red</label>
                                                    <select name="id_operador"
                                                        id="id_operador"
                                                        className={((this.verificarError("error_id_operador")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Operador de Red</option>
                                                        {
                                                            operadores.map((itemOperadores) => (
                                                                <option key={itemOperadores.ID_OPERADOR} value={itemOperadores.ID_OPERADOR}>{itemOperadores.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Operador de Red</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="id_departamento">Departamento</label>
                                                    <select name="id_departamento"
                                                        id="id_departamento"
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosVisita.map((itemDepartamentosVisitas) => (
                                                                <option key={itemDepartamentosVisitas.ID_DEPARTAMENTO} value={itemDepartamentosVisitas.ID_DEPARTAMENTO}>{itemDepartamentosVisitas.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="id_municipio">ID. Municipio</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="id_municipio" id="id_municipio" value={id_municipio} placeholder="ID. MUNICIPIO" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el ID. Municipio</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nombre" id="nombre" value={nombre} placeholder="NOMBRE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Mpio. Oper.</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterMunicipiosOperadores"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;